import { render, staticRenderFns } from "./misFacturas.vue?vue&type=template&id=7a23987a&"
import script from "./misFacturas.vue?vue&type=script&lang=js&"
export * from "./misFacturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports